import React, { useState, useEffect, useMemo } from "react";
import { Table } from "react-bootstrap";
import {
  getChoferes,
  deleteChofer,
  getChoferById,
} from "../helpers/rutaChoferes";
import ModalChofer from "./ModalChofer";
import "../css/tableclientes.css";

const COL_WIDTHS = {
  acciones: "120px",
  nro: "80px",
  razonSocial: "260px",
  domicilio: "260px",
  telefono: "140px",
  cuit: "150px",
  email: "240px",
  localidad: "180px",
};

const TableChoferes = () => {
  const [choferes, setChoferes] = useState({
    data: { choferes: [] },
    loading: true,
  });

  const [chofer, setChofer] = useState({});
  const [show, setShow] = useState(false);

  useEffect(() => {
    consultaChoferes();
  }, []);

  const consultaChoferes = () => {
    getChoferes().then((datos) => {
      console.log("📦 Choferes:", datos);

      setChoferes({
        data: datos || { choferes: [] },
        loading: false,
      });
    });
  };

  const handleClose = () => {
    setShow(false);
    consultaChoferes();
  };

  const handleShow = () => setShow(true);

  const modificaChofer = (id) => {
    getChoferById(id).then((resp) => {
      if (resp.ok) {
        setChofer(resp.chofer);
        handleShow();
      } else {
        console.error("❌ Error al obtener chofer:", resp.error);
      }
    });
  };

  const eliminarChofer = (id) => {
    const confirmar = window.confirm("¿Está seguro que desea borrar el chofer?");
    if (confirmar) {
      deleteChofer(id).then(() => {
        consultaChoferes();
      });
    }
  };

  const choferesOrdenados = useMemo(() => {
    const lista = Array.isArray(choferes?.data?.choferes)
      ? choferes.data.choferes
      : [];

    return [...lista]
      .filter((item) => item?.activo)
      .sort((a, b) =>
        String(a?.nombre || "").localeCompare(String(b?.nombre || ""), "es", {
          sensitivity: "base",
        })
      );
  }, [choferes]);

  return (
    <div className="table-container">
      {!choferes.loading && (
        <>
          <div className="col-12 mt-4" />

          <div style={{ overflowX: "auto" }}>
            <Table striped bordered hover className="table-container">
              <thead>
                <tr className="header">
                  <th
                    className="acciones"
                    style={{ width: COL_WIDTHS.acciones, minWidth: COL_WIDTHS.acciones }}
                  >
                    Acciones
                  </th>
                  <th style={{ width: COL_WIDTHS.nro, minWidth: COL_WIDTHS.nro }}>
                    Nro
                  </th>
                  <th
                    className="cli"
                    style={{ width: COL_WIDTHS.razonSocial, minWidth: COL_WIDTHS.razonSocial }}
                  >
                    Razón Social
                  </th>
                  <th
                    className="dom"
                    style={{ width: COL_WIDTHS.domicilio, minWidth: COL_WIDTHS.domicilio }}
                  >
                    Domicilio
                  </th>
                  <th
                    className="tel"
                    style={{ width: COL_WIDTHS.telefono, minWidth: COL_WIDTHS.telefono }}
                  >
                    Teléfono
                  </th>
                  <th
                    className="cuit"
                    style={{ width: COL_WIDTHS.cuit, minWidth: COL_WIDTHS.cuit }}
                  >
                    CUIT
                  </th>
                  <th
                    className="email"
                    style={{ width: COL_WIDTHS.email, minWidth: COL_WIDTHS.email }}
                  >
                    Email
                  </th>
                  <th
                    className="loca"
                    style={{ width: COL_WIDTHS.localidad, minWidth: COL_WIDTHS.localidad }}
                  >
                    Localidad
                  </th>
                </tr>
              </thead>

              <tbody>
                {choferesOrdenados.map((chofer) => (
                  <tr key={chofer._id}>
                    <td
                      style={{
                        width: COL_WIDTHS.acciones,
                        minWidth: COL_WIDTHS.acciones,
                        whiteSpace: "nowrap",
                      }}
                    >
                      <button
                        className="btn btn-primary"
                        onClick={() => modificaChofer(chofer._id)}
                      >
                        <i className="fa fa-pencil-square-o" aria-hidden="true" />
                      </button>

                      <button
                        className="btn btn-danger ml-2"
                        onClick={() => eliminarChofer(chofer._id)}
                      >
                        <i className="fa fa-trash-o" aria-hidden="true" />
                      </button>
                    </td>

                    <td style={{ width: COL_WIDTHS.nro, minWidth: COL_WIDTHS.nro }}>
                      {chofer.codcho}
                    </td>

                    <td
                      style={{
                        width: COL_WIDTHS.razonSocial,
                        minWidth: COL_WIDTHS.razonSocial,
                        textAlign: "left",
                      }}
                    >
                      {chofer.nombre}
                    </td>

                    <td
                      style={{
                        width: COL_WIDTHS.domicilio,
                        minWidth: COL_WIDTHS.domicilio,
                        textAlign: "left",
                      }}
                    >
                      {chofer.domicilio}
                    </td>

                    <td
                      style={{
                        width: COL_WIDTHS.telefono,
                        minWidth: COL_WIDTHS.telefono,
                      }}
                    >
                      {chofer.telefono}
                    </td>

                    <td
                      style={{
                        width: COL_WIDTHS.cuit,
                        minWidth: COL_WIDTHS.cuit,
                      }}
                    >
                      {chofer.cuit}
                    </td>

                    <td
                      style={{
                        width: COL_WIDTHS.email,
                        minWidth: COL_WIDTHS.email,
                      }}
                    >
                      {chofer.email}
                    </td>

                    <td
                      style={{
                        width: COL_WIDTHS.localidad,
                        minWidth: COL_WIDTHS.localidad,
                      }}
                    >
                      {chofer.localidad?.localidad || "-"}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>

          <ModalChofer
            show={show}
            handleClose={handleClose}
            chofer={chofer}
          />
        </>
      )}
    </div>
  );
};

export default TableChoferes;